import React, { useCallback, useContext, useEffect, useState } from 'react'

import { OrderValueInputSection } from '../styles'
import { CInput } from 'app/components/Common'
import { Text, View } from 'styles/reactnative'
import { useTradeStore } from '../../../../../../../hooks/trade/tradeStore'
import { useTradeModalStore } from 'app/hooks/trade/modalStore'
import { ThemeContext } from 'theme/ThemeProvider'
import { useOrderStore } from '../../../../../../../hooks/trade/orderStore'
import { Button, Space } from 'antd'
import { IconMinus, IconPlus } from '@tabler/icons-react'
import { FONTS } from '../../../../../../../constants'
import { useLogQueue } from '../../../../../../../hooks/trade/logQueue'
import { useTPLStore } from '../../../../../../../hooks/trade/tplStore'
import { debounce } from '@rowsncolumns/grid'

const OrderValueInput = () => {
	const { textw, onSecondary, point } = useContext(ThemeContext).theme.COLORS

	const { data: tradeStore, mutate: mutateTradeStore } = useTradeStore()
	const { data: orderStore, change: mutateOrderStore } = useOrderStore()
	const { change: mutateModalStore } = useTradeModalStore()
	const { data: tplStore, changeTPL } = useTPLStore()
	const { mutate: mutateLog } = useLogQueue()

	if (orderStore?.amount === undefined) {
		mutateOrderStore({ amount: 1 })
	}
	const setOrderAmount = data => {
		if (isNaN(data)) return

		const min = tradeStore?.min_amount || 1

		let temp = data
		if (temp < min) temp = min

		mutateOrderStore({
			amount: temp,
		})
	}

	const [profit, setProfit] = useState(false)
	const [loss, setLoss] = useState(false)
	const [profittick, setProfittick] = useState(5)
	const [losstick, setLosstick] = useState(5)

	useEffect(() => {
		if (!tradeStore?.ep_id) return

		let data = tplStore
			?.filter((i: any) => i.key == 'TPL' + tradeStore?.ep_id)
			?.map(d => {
				const [profit, loss, p, l] = d?.value?.split(':') || [
					5, 5, 0, 0,
				]
				return {
					profit: p == 1 ? true : false,
					profittick: +profit || 5,
					loss: l == 1 ? true : false,
					losstick: +loss || 5,
				}
			}) || [
			{
				profit: false,
				profittick: 5,
				loss: false,
				losstick: 5,
			},
		]

		if (data.length == 0) {
			data = [
				{
					profit: false,
					profittick: 5,
					loss: false,
					losstick: 5,
				},
			]
		}

		setProfit(data?.[0]?.profit)
		setLoss(data?.[0]?.loss)
		setProfittick(data?.[0]?.profittick)
		setLosstick(data?.[0]?.losstick)
	}, [tplStore, tradeStore?.ep_id])


	const debouncedMutateLogGT006 = useCallback(
		debounce((temp) => {
			mutateLog({
				log: "GT006",
				data: {
					amount: temp,
					ep_id: tradeStore?.ep_id,
					isMobile: true,
				},
			});
		}, 2000),
		[]
	);

	return (
		<OrderValueInputSection>
			<Text style={{
				color: textw,
				...FONTS.h7,
			}}>주문수량</Text>
			<Space size="small" style={{ alignItems: 'center' }}>
				<Button
					size="small"
					icon={<IconMinus />}
					onClick={() => {
						if (!orderStore?.amount || isNaN(orderStore?.amount)) {
							return
						}

						if (+orderStore?.amount <= 1) {
							return
						}

						setOrderAmount(orderStore?.amount - 1)

						mutateLog({
							log: 'GT006',
							data: {
								amount: orderStore?.amount - 1,
								ep_id: tradeStore?.ep_id,
								isMobile: true,
							},
						})
					}}
					style={{
						color: point,
						justifyContent: 'center',
						fontSize: 15,
						alignItems: 'center',
						minHeight: 34,
					}}
				/>
				<CInput
					placeholder={''}
					value={orderStore?.amount || 1}
					type={'text'}
					onChange={(e: any) => {
						let temp = parseInt(e.target.value + '')
						temp = Math.max(0, Math.min(temp, 999))

						setOrderAmount(temp);

						debouncedMutateLogGT006(temp);
					}
					}
					vStyle={{ padding: 0, flexDirection: 'row', width: '100%' }}
					style={{
						background: onSecondary,
						color: '#2B2E33',
						border: 'none',
						flex: 1,
						padding: 0,
						fontSize: 15,
						width: '100%',
						minHeight: 34,
						alignItems: 'center',
						justifyContent: 'center',
						textAlign: 'center',
						marginTop: 10,
					}}
				/>

				<Button
					size="small"
					icon={<IconPlus />}
					onClick={() => {
						setOrderAmount((orderStore?.amount || 0) + 1)

						mutateLog({
							log: 'GT006',
							data: {
								amount: (orderStore?.amount || 0) + 1,
								ep_id: tradeStore?.ep_id,
								isMobile: true,
							},
						})
					}}
					style={{
						color: point,
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: 34,
					}}
				/>
				<Button
					size="small"
					type={undefined}
					style={{
						color: textw,
						whiteSpace: 'nowrap',
						fontSize: 12,
						letterSpacing: -0.5,
						minHeight: 34,
					}}>
					{tradeStore?.coin_type}
				</Button>
			</Space>
		</OrderValueInputSection>
	)
}

export default OrderValueInput
